const prepareShow = info => {
  return info
}

export default {
  doLoad () {
    this.$http.get('/v1/dweller/tenant/overview/info')
      .then(({data}) => {
        this.infos = prepareShow({...data})
      })
  },
  mtel (v) {
    v = v.replace(/\D/g, '')
    v = v.replace(/^(\d\d)(\d)/g, '($1) $2')
    if (v.length < 14) {
      v = v.replace(/(\d{4})(\d)/, '$1-$2')
    } else {
      v = v.replace(/(\d{5})(\d)/, '$1-$2')
    }
    return v
  },
  getTowersDweller () {
    this.$http.get('/v1/dweller/towers/search')
      .then(({data}) => {
        this.towers = data
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/profile/me/components/overview/components/info/resources/methods.js